import { render, staticRenderFns } from "./uploadPictures.vue?vue&type=template&id=5a7c22c6&scoped=true"
import script from "./uploadPictures.vue?vue&type=script&lang=js"
export * from "./uploadPictures.vue?vue&type=script&lang=js"
import style0 from "./uploadPictures.vue?vue&type=style&index=0&id=5a7c22c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7c22c6",
  null
  
)

export default component.exports